














































import { computed, defineComponent } from '@vue/composition-api'
import { useCreateLeadForm } from '@/composables/useCreateLeadForm'

export default defineComponent({
    name: 'CreateLeadVerticalStep2',
    setup() {
        const { state, steps } = useCreateLeadForm()

        const referredByBranchName = computed<string>(() => {
            return state.referral.referredByBranch?.name || '-'
        })

        const assignedToBranchName = computed<string>(() => {
            return state.referral.assignedToBranch?.name || '-'
        })

        const assignedToName = computed<string>(() => {
            return state.referral.assignedTo?.name || '-'
        })

        return {
            state,
            steps,

            referredByBranchName,
            assignedToBranchName,
            assignedToName,
        }
    },
})
